import { Box, CircularProgress } from '@mui/material'

import { imagePreviewBox } from 'elements/FileUpload/common/styles'
import { concatToSXProp } from 'utils/style'

export default function ImagePreviewLoading(): JSX.Element {
  return (
    <Box
      className="file-upload-file-load"
      sx={concatToSXProp(imagePreviewBox, {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: 'text.secondary',
      })}
    >
      <CircularProgress color="inherit" />
    </Box>
  )
}
